import { type WorkspaceAgentMentionRowItem } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/types';
import { splitWorkspaceAgentMentionLibraryRun } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/workspaceAgentMentionItems';

export const WORKSPACE_AGENT_SELECT_ASSET_LIBRARIES_HEADING_ROW_ID = 'libraries-heading';

/** Section label only — much shorter than a board/library tree row (36px). */
export const WORKSPACE_AGENT_SELECT_ASSET_LIBRARIES_HEADING_ROW_ESTIMATE_PX = 16;

export type WorkspaceAgentSelectAssetVirtualRow =
  | { id: typeof WORKSPACE_AGENT_SELECT_ASSET_LIBRARIES_HEADING_ROW_ID; kind: 'libraries-heading' }
  | { id: string; item: WorkspaceAgentMentionRowItem; itemIndex: number; kind: 'item' };

export const toWorkspaceAgentSelectAssetVirtualRows = (
  items: readonly WorkspaceAgentMentionRowItem[],
): WorkspaceAgentSelectAssetVirtualRow[] => {
  const { firstLibraryIndex, leadingItems, libraryRunItems } = splitWorkspaceAgentMentionLibraryRun([...items]);
  const rows: WorkspaceAgentSelectAssetVirtualRow[] = leadingItems.map((item, index) => ({
    id: item.id,
    item,
    itemIndex: index,
    kind: 'item',
  }));

  if (libraryRunItems.length === 0) {
    return rows;
  }

  rows.push({ id: WORKSPACE_AGENT_SELECT_ASSET_LIBRARIES_HEADING_ROW_ID, kind: 'libraries-heading' });

  libraryRunItems.forEach((item, index) => {
    rows.push({
      id: item.id,
      item,
      itemIndex: firstLibraryIndex + index,
      kind: 'item',
    });
  });

  return rows;
};
